export default "__VITE_ASSET__BjcCuKC9__"